/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}[_nghost-%COMP%]     .full-calendar-container{height:100%}[_nghost-%COMP%]     .full-calendar-container   .fc{height:100%;overflow:auto}"];
export { styles as styles };
